import { render } from "./Loader.vue?vue&type=template&id=3a0af43e&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=3a0af43e&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\OMS\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a0af43e"]])

export default __exports__